import { createIcon } from "@chakra-ui/react";

const ProjectIcon = createIcon({
  displayName: "ProjectIcon",
  viewBox: "0 0 24 24",
  path: (
    <>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.0728 10.5L8.70772 8.5H4.5V18.5H19.5V10.5H10.0728ZM3 8C3 7.44771 3.44772 7 4 7H8.97181C9.3023 7 9.61145 7.16329 9.79776 7.43626L10.8651 9H20C20.5523 9 21 9.44772 21 10V19C21 19.5523 20.5523 20 20 20H4C3.44772 20 3 19.5523 3 19V8Z"
        fill="currentColor"
      />
      <path
        d="M5 5.5H10.7077L12.0728 7.5H21V7C21 6.44772 20.5523 6 20 6H12.8651L11.7978 4.43626C11.6115 4.16329 11.3023 4 10.9718 4H6C5.44772 4 5 4.44771 5 5V5.5Z"
        fill="currentColor"
      />
    </>
  ),
});

export default ProjectIcon;
